// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Slider__Wrapper_1poWl"};